import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import { ISOTService } from '../../services';
import { NumberPad } from "../../directives/numberPad/numberPad.component";

export interface CouponNumberPadDialogConfig {
  sot_service: ISOTService;
}

@Component({
  selector: "sot-couponnumberpaddialog",
  templateUrl: "./couponnumberpaddialog.component.html",
  styleUrls: ["./couponnumberpaddialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

/** Coupon entry dialog — returns the entered coupon code string, or undefined when the user cancels. */
export class CouponNumberPadDialogComponent {
  @ViewChild("numberPad") numberPad: NumberPad;

  public static readonly couponCodeLength: number = 9;
  public static readonly couponCodeMinLength: number = 3;

  /** Template binding — delegates to the static constant. */
  public get couponCodeLength(): number { return CouponNumberPadDialogComponent.couponCodeLength; }
  /** Template binding — delegates to the static constant. */
  public get couponCodeMinLength(): number { return CouponNumberPadDialogComponent.couponCodeMinLength; }

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<CouponNumberPadDialogComponent, string>
    , private _coreLogService: CoreLogService
    , @Inject(MAT_DIALOG_DATA) public config: CouponNumberPadDialogConfig) {
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }
  public get isModeOne(): boolean {
    return this.config.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.config.sot_service.Accessabilty.useModeTwo;
  }
  public get couponString(): string {
    const me = this;
    return me.numberPad ? me.numberPad.numberPadResult : "";
  }

  public get submitDisabled() {
    const me = this;
    return me.numberPad ? me.numberPad.submitDisabled : true;
  }

  public submit(): void {
    const me = this;
    if (!me.submitDisabled) {
      me.dialogRef.close(me.couponString);
    } else {
      me.numberPad.toggleInputValid();
    }
    me.PushChanges();
  }

  public cancel(): void {
    const me = this;
    me.dialogRef.close(undefined);
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("CouponNumberPadDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}